
// export const staticfileUrl = process.env.NODE_ENV === 'development' ? 'https://test.vsj888.com/' : 'https://test.vsj888.com/';
// export const extUrl = process.env.NODE_ENV === 'development' ? '/alliance/api/v1/' : '/alliance/api/v1/';


// export const urlConfig="http://175.10.20.87:8881/api/";               	 //测试服务器
export const urlConfig="http://recruit.rzmevc.com/api/";               	 //测试服务器
